export { DotsHorizontal as default } from './DotsHorizontal';
